import React, { useState, useEffect, useRef } from 'react';
import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
import { RecruitNav } from "./index";
import * as styles from "./RecruitHeaderPc.module.scss"

const HeaderPc = ({ pageName }) => {
  const target = useRef(null);
  const [changeLogo, setLogo] = useState(false);
  const [classNames, setClassNames] = useState([styles.item, styles.scroll]);
  useEffect(() => {

    const targetTopPosition = target.current.getBoundingClientRect().top;
    const scrollOffset = 1500;
    const showTarget = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      if (scrollPosition > targetTopPosition + scrollOffset) {
        setClassNames([styles.item, styles.scrollShow]);
      } else {
        setClassNames([styles.item, styles.scroll]);
      }
    }
    const changeLogoFunc = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      if (scrollPosition > targetTopPosition + scrollOffset) {
        setLogo(true);
      } else {
        setLogo(false);
      }
    }
    showTarget();
    const onScroll = () => {
      showTarget();
      changeLogoFunc();
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div ref={target} className={classNames.join(" ")}>
      <div className={styles.Header__inner}>
        <div className={styles.Header__logo}>
        {
          changeLogo ?
          <StaticImage
            layout="fullWidth"
            src="../../images/recruit/logo-after@2x.png"
            alt="logo"
            placeholder="tracedSVG"
          />
          :
          <StaticImage
            layout="fullWidth"
            src="../../images/recruit/logo.png"
            alt="logo"
            placeholder="tracedSVG"
          />
        }
        </div>
        <RecruitNav pageName={pageName} />
      </div>
    </div>
  )
}

export default HeaderPc